import { Grid, GridColumn } from "@progress/kendo-react-grid";
import React, { Fragment } from "react";
import { setSubscriptionPlans } from "../../../redux/slices/accountmanagementslice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

const SubscriptionPlan = (props) => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.accountManagementPage);
  const navigate = useNavigate();

  const { t } = useTranslation();

  // Custom row rendering
  const rowRender = (trElement, props) => {
    const isCurrent = props.dataItem.IsCurrent;
    const isSelected = props.dataItem.IsSelected;

    // Style conditions for subscribed and selected rows
    let style = {};
    if (isCurrent) {
      style.backgroundColor = currentTheme.gridSubscribedRow; // Subscribed rows
    }
    if (isSelected) {
      style.backgroundColor = currentTheme.gridSelectedRow; // Selected row
    }

    return React.cloneElement(trElement, { style }, trElement.props.children);
  };

  // Handle row click
  const handleRowClick = (event) => {
    // Prevent clicking on rows that are already subscribed
    if (event.dataItem.IsCurrent) {
      return;
    }

    const updatedData = pageState.formValues?.SubscriptionPlans?.map(
      (item) =>
        item.Name === event.dataItem.Name
          ? { ...item, IsSelected: !item.IsSelected } // Toggle the clicked row
          : { ...item, IsSelected: false } // Unselect all other rows
    );

    // Dispatch the updated data to the Redux store
    dispatch(setSubscriptionPlans(updatedData));
  };

  // Determine if any row is selected
  const isButtonDisabled = !pageState.formValues?.SubscriptionPlans?.some(
    (plan) => plan.IsSelected
  );

  return (
    <Fragment>
      <h4>{t("accountmang.tabs.sub")}</h4>
      <div className="accountmanagement-grid-container">
        <Grid
          data={pageState.formValues.SubscriptionPlans}
          rowRender={rowRender}
          onRowClick={handleRowClick}
          style={{ cursor: "pointer" }}
        >
          <GridColumn field="Name" title={t("accountmang.tabs.plan")} />
          <GridColumn
            field="TotalReports"
            title={t("accountmang.tabs.reports")}
            cell={(props) => (
              <td>
                {props.dataItem.TotalReports === null
                  ? t("accountmang.tabs.unlimited")
                  : props.dataItem.TotalReports}
              </td>
            )}
          />
          <GridColumn
            field="TotalAlerts"
            title={t("accountmang.tabs.alerts")}
            cell={(props) => (
              <td>
                {props.dataItem.TotalAlerts === null
                  ? t("accountmang.tabs.unlimited")
                  : props.dataItem.TotalAlerts}
              </td>
            )}
          />
          <GridColumn
            field="TotalUsers"
            title={t("accountmang.tabs.users")}
            cell={(props) => (
              <td>
                {props.dataItem.TotalUsers === null
                  ? t("accountmang.tabs.unlimited")
                  : props.dataItem.TotalUsers}
              </td>
            )}
          />
          <GridColumn field="Storage" title={t("accountmang.tabs.storage")} />
          <GridColumn field="Price" title={t("accountmang.tabs.price")} />
          <GridColumn field="BillingCycle" title={t("accountmang.tabs.cycle")} />
        </Grid>
      </div>
      {/* <button
        className="btn btn-primary"
        style={{ marginTop: "20px", padding: "5px 15px", float: "right" }}
        disabled={isButtonDisabled} // Disable if no plan is selected
        onClick={() => {
          const selectedPlan = pageState.formValues?.SubscriptionPlans?.find(
            (plan) => plan.IsSelected
          );
          if (selectedPlan) {
            props.onResizeClick(selectedPlan); // Pass the selected plan's Id
          }
        }}
      >
        Resize
      </button> */}

      <Button 
        className="accountmanagement-resize-button"
        style={{
          padding: 8,
          color: currentTheme.touchColor,
          fontWeight: 500,
          float:"right",
          marginTop:"20px"
        }}
        disabled={isButtonDisabled} // Disable if no plan is selected
        onClick={() => {
          const selectedPlan = pageState.formValues?.SubscriptionPlans?.find(
            (plan) => plan.IsSelected
          );
          if (selectedPlan) {
            props.onResizeClick(selectedPlan); // Pass the selected plan's Id
          }
        }}
      >
            {t("accountmang.tabs.resize")}
      </Button> 
    </Fragment>
  );
};

export default SubscriptionPlan;
